import { MutationKey } from '@tanstack/react-query';

const base: MutationKey = ['login'];

export const loginMutationKeys = {
  // * BASE
  baseKey: base,

  // * Send Login
  sendLogin: [...base, 'sendLogin'],
};